var _Circle, _Path, _Path2, _Path3, _Path4, _Path5, _Path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgChainEthereum = function SvgChainEthereum(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EDF0F4"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "m11.967 4.8-.096.324v9.408l.096.096 4.367-2.582L11.967 4.8Z",
    fill: "#343434"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M11.967 4.8 7.6 12.046l4.367 2.582V4.8Z",
    fill: "#8C8C8C"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "m11.967 15.455-.054.065v3.352l.054.157 4.37-6.155-4.37 2.58Z",
    fill: "#3C3C3B"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    d: "M11.967 19.029v-3.574L7.6 12.875l4.367 6.154Z",
    fill: "#8C8C8C"
  })), _Path5 || (_Path5 = /*#__PURE__*/React.createElement(Path, {
    d: "m11.967 14.628 4.367-2.582-4.367-1.985v4.567Z",
    fill: "#141414"
  })), _Path6 || (_Path6 = /*#__PURE__*/React.createElement(Path, {
    d: "m7.6 12.046 4.367 2.582V10.06L7.6 12.046Z",
    fill: "#393939"
  })));
};
export default SvgChainEthereum;